var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVirtik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 28,
    viewBox: "0 0 150 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_1365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6698 5.48242L58.6089 14.8117L60.1695 18.4478L65.8188 5.48242H62.6698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9765 18.5655L51.3295 5.48242H47.915L55.3281 22.4418H58.4286L58.5348 22.1994L56.9765 18.5655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3975 5.48242H71.2485V22.4418H74.3975V5.48242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.536 8.14661H107.158V22.4418H110.307V8.14661H115.928V5.48242H101.536V8.14661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.087 5.48242H121.938V22.4418H125.087V5.48242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.468 5.44922H133.303V22.494H136.468V5.44922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.999 5.49023H146.225L138.41 13.9745L138.414 13.9791L138.403 13.9907L145.574 22.5466H149.175L142.083 14.0853L149.999 5.49023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8099 11.5149C96.8099 7.75875 94.0487 5.48242 89.5884 5.48242H82.6094V22.4418H85.7584V8.14661H89.4407C92.2018 8.14661 93.6332 9.38173 93.6332 11.5149C93.6332 13.6481 92.2041 14.9063 89.4407 14.9063H88.5611L93.744 22.4418H97.0985L93.1969 16.8687C95.4986 15.9729 96.8076 14.0821 96.8076 11.5149H96.8099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3614 5.63971L40.2261 0.588379H32.1389L28.2765 5.63971L20.0508 16.622L24.0932 22.0219L36.3614 5.63971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2893 0.588602H7.96023L0 0.583984L4.92897 7.2329L11.8249 7.23752L19.2172 7.28138L24.2893 0.588602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0931 22.0219L20.0507 16.6219L13.0555 7.25342H4.96826L16.0082 22.0219L20.0507 27.4195L24.0931 22.0219Z",
    fill: "url(#paint0_linear_23_1365)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_1365",
    x1: 21.3435,
    y1: 23.2801,
    x2: 8.69673,
    y2: 7.58817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#508EEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 26.8358,
    fill: "white",
    transform: "translate(0 0.582031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVirtik);
export default __webpack_public_path__ + "static/media/logo_virtik.09676ec3c96a5e5123c981db98f829d7.svg";
export { ForwardRef as ReactComponent };